import React, { useState, useEffect, useRef } from 'react'
import chatbotActions from '@takedapdt/biolife-core/src/Stores/Chatbot/Actions'
import OvershadowModal from './Components/OvershadowingPopup'
import { useScreenSize } from '../../Contexts/ResponsiveContextProvider'
// import chatbotActions from '../../../../biolife-core/src/Stores/Chatbot/Actions'
import { useDispatch, useSelector } from 'react-redux'
import {
  ChatbotMainContent,
  BlueDot,
  PopupImageContainer,
  PopupImage,
  MainChatbotContainer,
  ChatBox,
  StyledSpan,
  ChatbotBody,
  ModalContainer
} from './chatbot.styled'
import ChatIcon from '../../../assets/media/icons/OrangeChatbotIcon1.svg'
import ChatBotHeader from './Header'
import MessageArea from './MessageArea'
import BoxedModal from './Components/BoxedModal'
import CloseModalContent from './Modals/EndChatPopup'
import Inactivity5min from './Modals/Inactivity5min'
import Inactivity10min from './Modals/Inactivity10min'
import { throttle, debounce } from 'lodash'
import { getCustomComponentOnCTAClick } from './utils/getCustomComponentOnCTAClick'
import LeadGenSuccessPopup from './Modals/LeadGenForm/SuccessPopup'

const Chatbot = React.forwardRef((props, chatbotWindow) => {
  const {
    isAuthenticatedUser,
    handleIsChatbotOpen,
    outsideChatbot,
    handleOutsideChatbot,
    showInactivityPopup,
    handleInactivityPopup,
    chatbotMinimized,
    handleChatbotMinized
  } = props
  const popupStatInitialValue = {
    leadGenSuccessPopup: false
  }
  const { innerWidth, innerHeight } = window
  const dispatch = useDispatch()
  const { isMobileWidth, isTabletWidth } = useScreenSize()
  const openChatbot = useSelector((state) => state.chatbot.openChatbot)
  const showHideChatbot = useSelector((state) => state.chatbot.showChatbot)
  const interval1 = useRef()
  const interval2 = useRef()
  const currentSessionID = useRef(null)
  const currentIntent = useRef('')
  const chatboxRef = useRef(null)
  // For second timer we just start the same timoutValue again after the firstTimout
  const timoutValue = 5 * 60 * 1000
  const [afterInactivityContinued, setAfterInactivityContinued] = useState(false)
  const [selectedLanguage, setSelectedLanguage] = useState('English')
  const [messagesArr, setMessagesArr] = useState([])
  const [resetChatbot, setResetChatbot] = useState(false)
  const [chatOpen, setChatOpen] = useState(false || openChatbot)
  const [openEndChatPopup, setEndChatPopup] = useState(false)
  const [renderCTAComponent, setRenderCTAComponent] = useState(null)
  const [commAlreadyStarted, setCommAlreadyStarted] = useState(false)
  const [popupState, setPopupState] = useState(popupStatInitialValue)
  const [chatbotHeight, setChatbotHeight] = useState(null)
  const [newMessageHandledWithReset, setNewMessageHandledWithReset] = useState(false)
  // inputText is given through fetchMessage function
  // chatStarted is a flag boolean which is used to create a chatSessionId at backend
  const initialStateChatbotData = {
    localeId: selectedLanguage === 'Español' ? 'es_US' : 'en_US',
    chatStarted: false,
    chatEnded: false,
    sessionTimout: false
  }
  const [chatbotData, setChatbotData] = useState({
    ...initialStateChatbotData
  })

  const handlePopupState = (value) => {
    setPopupState(value)
  }
  const changesOnSessionTimout = () => {
    clearTimeout(interval1.current)
    clearTimeout(interval2.current)
    interval1.current = null
    interval2.current = null
    handleGetNewMessage(true)
    localStorage.removeItem('chatbotData')
    openEndChatPopup && setEndChatPopup(false)
    changeChatbotData((prev)=>{
      return {
        ...prev,
        chatSessionID: currentSessionID.current, sessionTimout: true
      }
    });
    sendChatEndedMessage('', { ...chatbotData, chatSessionID: currentSessionID.current, sessionTimout: true })
  }

  useEffect(()=>{
    /**
    * This will close the renderCTAComponent if any other popup comes over.
    */
    if(showInactivityPopup || openEndChatPopup) {
      setRenderCTAComponent(null)
      handlePopupState(popupStatInitialValue)
    }
  },[showInactivityPopup, openEndChatPopup])

  useEffect(() => {
    if (messagesArr && !messagesArr.length && localStorage.getItem('chatbotData') && localStorage.getItem('chatbotData').length) {
      // chatStarted once true will always be false because chatSessionID is true only once at start to create chatSession
      // So if bot is getting data from localStorage we know chat has started and thus false
      setChatbotData((prev) => {
        return { ...prev, chatStarted: false }
      })
    }
  }, [])

  useEffect(() => {
    const localStorageIsAuthenticated = localStorage.getItem("isAuthenticatedForChatbot");
    const parsedLocalStorageIsAuthenticated = !localStorageIsAuthenticated || localStorageIsAuthenticated === "null" ? null : JSON.parse(localStorageIsAuthenticated);
    const newIsAuthenticatedUser = isAuthenticatedUser?.loginId || null;
    if (parsedLocalStorageIsAuthenticated === "loggedIn" && !newIsAuthenticatedUser) {
      localStorage.setItem("isAuthenticatedForChatbot", null)
      localStorage.removeItem("chatbotData");
      resetBotState();
    }
  }, [isAuthenticatedUser]);

  useEffect(() => {
    if (chatOpen && outsideChatbot && isMobileWidth) {
      dispatch(chatbotActions.openChatbot(false))
      handleOutsideChatbot(false)
    }
  }, [outsideChatbot])

  useEffect(() => {
      setChatOpen(openChatbot)
  }, [openChatbot])

  useEffect(() => {
    if (chatboxRef.current) {
      const newChatbotHeight = chatboxRef.current.offsetHeight;
      setChatbotHeight(newChatbotHeight);
    }
    if (chatOpen) {
      handleIsChatbotOpen(true)
    } else {
      handleIsChatbotOpen(false)
    }
    if (chatOpen && commAlreadyStarted) {
      handleChatbotMinized(true)
    }
  }, [chatOpen, commAlreadyStarted])

  useEffect(() => {
    if (!chatbotMinimized) {
      clearTimeout(interval1.current)
      clearTimeout(interval2.current)
      interval1.current = null
      interval2.current = null
    }
  }, [chatbotMinimized])

  useEffect(() => {
    if (showInactivityPopup === 0 && afterInactivityContinued) {
      resetTimeouts(chatbotMinimized)
    }
  }, [showInactivityPopup, afterInactivityContinued])

  useEffect(() => {
    if (commAlreadyStarted) {
      interval1.current = setTimeout(() => {
        handleInactivityPopup(5)
        interval2.current = setTimeout(() => {
          handleInactivityPopup(10)
          changesOnSessionTimout()
        }, timoutValue)
      }, timoutValue)
    }
  }, [commAlreadyStarted])

  const resetTimeouts = (chatbotMinimized) => {
    if (!commAlreadyStarted) {
      clearTimeout(interval1.current)
      clearTimeout(interval2.current)
      return
    }
    if (showInactivityPopup) {
      // Dont want to reset Timer if the inactivity popup has appeared
      return
    }
    clearTimeout(interval1.current)
    clearTimeout(interval2.current)

    interval1.current = setTimeout(() => {
      handleInactivityPopup(5)
      interval2.current = setTimeout(() => {
        handleInactivityPopup(10)
        changesOnSessionTimout()
        clearTimeout(interval1.current)
        clearTimeout(interval2.current)
      }, timoutValue)
    }, timoutValue)
  }

  useEffect(() => {
    setChatbotData((prev) => {
      return {
        ...prev,
        localeId: selectedLanguage === 'Español' ? 'es_US' : 'en_US'
      }
    })
  }, [selectedLanguage])

  const changeChatbotData = (value) => {
    setChatbotData(value)
  }

  const changeCTARenderComponent = (value) => {
    setRenderCTAComponent(value)
  }

  const changeChatbotSelectedLanguage = (value) => {
    // console.log('value of language Selected>>', value, value === 'Español' ? 'es_US' : 'en_US')
    setSelectedLanguage(value)
  }

  const changeCommAlreadyStarted = () => {
    setCommAlreadyStarted((prev) => !prev)
  }

  const openCloseChatbotpopup = () => {
    // Open End Chatbot pop up
    if (!commAlreadyStarted) {
      // Not Showing popup if the user has not started the conversation
      closeChatbotAndReset()
      return
    }
    setEndChatPopup(true)
  }

  const CrossCloseCTACompPopup = ({operation, component})=> {
    /**
     * @function CrossCloseCTACompPopup
     * @description
     * Closes the CTA component popup and resets the rendered CTA component.
     * Typically triggered when the user clicks on the close button (cross icon) / Return To Chat.
     *
     * @param {string} operation - The type of operation being performed (e.g., automatic or manual).
     * @param {string} component - The name of the component being closed in renderCTAComponent.
     * - There can be many components, and based on the component, different operations can be performed.
     * @returns {void} - This function does not return any value.
    */
    switch(component){
      case "register":{
        if(operation === "manual"){
          let data={...chatbotData, inputText: "", isLeadGenFormClosed: true};
          changeChatbotData((prev)=>{
            return {
              ...prev,
              isLeadGenFormClosed: true,
            }
          })
          dispatch(chatbotActions.getChatbotResponse(data));
        }
        break;
      }
    }
    setRenderCTAComponent(null)
  }

  const CrossCloseChatbotpopup = () => {
    // Open End Chatbot pop up
    setEndChatPopup(false)
  }

  const toggle = (e) => {
    dispatch(chatbotActions.openChatbot(!chatOpen))
    if (chatOpen && resetChatbot) {
      setResetChatbot(false)
    }
  }

  const resetBotState = (value) => {
    setResetChatbot(value)
    changeChatbotSelectedLanguage('English')
    handleChatbotMinized(false)
    showInactivityPopup && handleInactivityPopup(0)
    setRenderCTAComponent(null)
    resetTimeouts(chatbotMinimized)
    if (commAlreadyStarted) {
      sendChatEndedMessage('')
      setCommAlreadyStarted(false)
      localStorage.removeItem('chatbotData')
    }
    // As chatbot data will have many other backendData variables too we need to set it to initial state now.
    changeChatbotData(initialStateChatbotData)
  }

  const handleGetNewMessage = (value) => {
    setNewMessageHandledWithReset(value)
  }

  const closeChatbotAndReset = () => {
    toggle()
    CrossCloseChatbotpopup()
    resetBotState(true)
    if (commAlreadyStarted) {
      handleChatbotMinized(false)
    }
  }

  const sendChatEndedMessage = (inputText, extraData = {}) => {
    let data = { inputText, ...chatbotData, ...extraData, chatEnded: true, chatSessionID: currentSessionID.current }
    changeChatbotData((prev)=>{
      return {
        ...prev,
        ...data
      }
    })
    dispatch(chatbotActions.getChatbotResponse(data))
  }

  const messageArrSetter = (value) => {
    setMessagesArr(value)
  }

  const createLoadingBotMessage = () => {
    setMessagesArr((prev) => {
      return [
        ...prev,
        {
          type: 'loading',
          messageFrom: 'bot',
          message: [
            {
              content: '...',
              contentType: 'PlainText'
            }
          ]
        }
      ]
    })
  }

  const createBotText = (message) => {
    if (!Array.isArray(message)) return
    const newData = messagesArr.slice(0, messagesArr.length - 1)
    setMessagesArr((prev) => {
      return [
        ...newData,
        {
          messageFrom: 'bot',
          message
        }
      ]
    })
  }

  const createUserText = (userMessage) => {
    setMessagesArr((prev) => {
      return [
        ...prev,
        {
          messageFrom: 'user',
          message: userMessage
        }
      ]
    })
  }

  const resumeChatInactivity = () => {
    handleInactivityPopup(0)
    setAfterInactivityContinued(true)
  }

  const closeLeadGenSuccessPopup = () => {
    handlePopupState((prev) => ({
      ...prev,
      leadGenSuccessPopup: false,
    }));
  };

  return (
    <MainChatbotContainer $showHideChatbot={showHideChatbot} $chatOpen={chatOpen} ref={chatbotWindow} >
      {chatOpen && (
        <ChatBox
          ref={chatboxRef}
          $innerWidth={innerWidth}
          $innerHeight={innerHeight}
          onClick={throttle(() => {
            resetTimeouts()
          }, 50)}
          onMouseMove={throttle(() => {
            resetTimeouts()
          }, 50)}
          onKeyPress={debounce(() => {
            resetTimeouts()
          }, 50)}
        >
          <ChatBotHeader
            openCloseChatbotpopup={openCloseChatbotpopup}
            toggleChatbot={toggle}
            text='Hey There!'
            resetBotState={resetBotState}
            handleGetNewMessage={handleGetNewMessage}
          />
          <ModalContainer>
            {/* <ChatbotBody> */}
            <MessageArea
              messagesArr={messagesArr}
              messageArrSetter={messageArrSetter}
              createBotText={createBotText}
              createUserText={createUserText}
              createLoadingBotMessage={createLoadingBotMessage}
              commAlreadyStarted={commAlreadyStarted}
              changeCommAlreadyStarted={changeCommAlreadyStarted}
              resetChatbot={resetChatbot}
              resetBotState={resetBotState}
              changeChatbotData={changeChatbotData}
              chatbotData={chatbotData}
              initialStateChatbotData={initialStateChatbotData}
              changeChatbotSelectedLanguage={changeChatbotSelectedLanguage}
              selectedLanguage={selectedLanguage}
              currentSessionID={currentSessionID}
              currentIntent={currentIntent}
              resetTimeouts={resetTimeouts}
              changeCTARenderComponent={changeCTARenderComponent}
              handleGetNewMessage={handleGetNewMessage}
              newMessageHandledWithReset={newMessageHandledWithReset}
            />
            {/* </ChatbotBody> */}
            {
              isMobileWidth? (
                <OvershadowModal
                maxWidthMobile={`${innerWidth}px`}
                mobileWidth={`39rem`}
                maxHeightMobile={`70rem`}
                isOpen={renderCTAComponent}
                onClose={CrossCloseCTACompPopup}
                noCloseIcon={true}
                >
                {renderCTAComponent && getCustomComponentOnCTAClick({component: renderCTAComponent, data: {...chatbotData,selectedLanguage}, handlePopupState, CrossCloseCTACompPopup, changeChatbotData})} 
                </OvershadowModal>
              ) : (
              <BoxedModal
                maxWidth={'37rem'}
                maxHeight={`calc(${chatbotHeight}px - 20%)`}
                maxWidthMobile={`${innerWidth}px`}
                isOpen={renderCTAComponent}
                closeFunction={CrossCloseCTACompPopup}
                modalContainerStyle={{ bottom: '10%' }}
                noCloseIcon={true}
                noModalContentPadding={true}
              >
                {renderCTAComponent && getCustomComponentOnCTAClick({component: renderCTAComponent, data: {...chatbotData,selectedLanguage}, handlePopupState, CrossCloseCTACompPopup, changeChatbotData})} 
              </BoxedModal>
              )
            }
            
            <BoxedModal
              maxWidth={'37rem'}
              maxHeight={'40rem'}
              isOpen={popupState.leadGenSuccessPopup}
              closeFunction={closeLeadGenSuccessPopup}
              modalContainerStyle={{ bottom: '10%' }}
            >
              <LeadGenSuccessPopup selectedLanguage={selectedLanguage} handlePopupState={handlePopupState}/>
            </BoxedModal>
            <BoxedModal
              maxWidth={'37rem'}
              maxHeight={'40rem'}
              isOpen={openEndChatPopup}
              closeFunction={CrossCloseChatbotpopup}
              modalContainerStyle={{ bottom: '10%' }}
            >
              <CloseModalContent closeFunction={CrossCloseChatbotpopup} closeChatbotAndReset={closeChatbotAndReset} selectedLanguage={selectedLanguage}/>
            </BoxedModal>
            <BoxedModal
              maxWidth={'37rem'}
              maxHeight={'40rem'}
              isOpen={showInactivityPopup === 5}
              closeFunction={resumeChatInactivity}
              modalContainerStyle={{ bottom: '10%' }}
            >
              <Inactivity5min
                resumeChat={resumeChatInactivity}
                selectedLanguage={selectedLanguage}
                resetChat={() => {
                  handleInactivityPopup(0)
                  handleGetNewMessage(true)
                  handleChatbotMinized(false)
                  resetBotState(true)
                  resetTimeouts(chatbotMinimized)
                  openEndChatPopup && setEndChatPopup(false)
                }}
              />
            </BoxedModal>
            <BoxedModal
              maxWidth={'37rem'}
              maxHeight={'40rem'}
              isOpen={showInactivityPopup === 10}
              noCloseIcon={true}
              modalContainerStyle={{ bottom: '10%' }}
            >
              <Inactivity10min
                resetChat={() => {
                  handleInactivityPopup(0)
                  handleChatbotMinized(false)
                  resetBotState(true)
                  resetTimeouts(chatbotMinimized)
                  openEndChatPopup && setEndChatPopup(false)
                }}
                selectedLanguage={selectedLanguage}
              />
            </BoxedModal>
          </ModalContainer>
        </ChatBox>
      )}
      {!chatOpen && (
        <ChatbotMainContent>
          <PopupImageContainer onClick={toggle}>
            <PopupImage src={ChatIcon} />
            <StyledSpan id='askUs'>Ask Us</StyledSpan>
          </PopupImageContainer>
          {showInactivityPopup ? <BlueDot /> : <></>}
        </ChatbotMainContent>
      )}
    </MainChatbotContainer>
  )
})

export default Chatbot
